import * as React from 'react';
import * as ReactDataGrid from 'react-data-grid';
import * as moment from 'moment';
import { ProspectGridColumns } from '../../utilities/Enums';
import { formatPhoneNumber } from '../../utilities/Utils';
import { FlatProspect } from '../../api/Prospect';
import '../../styles/Header.css';

const columns = [
    { key: ProspectGridColumns.Name, name: 'Name', resizable: true, sortable: true },
    {
        key: ProspectGridColumns.TourDate,
        name: 'Tour Date',
        resizable: true,
        sortable: true
    },
    {
        key: ProspectGridColumns.TimeSlot,
        name: 'Time Slot',
        resizable: true,
        sortable: false
    },
    {
        key: ProspectGridColumns.Status,
        name: 'Status',
        resizable: true,
        sortable: true
    },
    {
        key: ProspectGridColumns.MoveInDate,
        name: 'Move In',
        resizable: true,
        sortable: true
    },
    { key: ProspectGridColumns.Email, name: 'Email', resizable: true, sortable: true },
    { key: ProspectGridColumns.Phone, name: 'Phone #',  resizable: true, sortable: true }
];

interface Props {
    rows: FlatProspect[];
    onSort: (sortColumn: ProspectGridColumns, sortDirection: 'ASC' | 'DESC' | 'NONE') => void;
    selectProspect: (id: string) => void;
}

const ProspectGrid = (props: Props) => {
    const rowGetter = (i: number) => {
        let prospect = props.rows[i];
        let selectedTourDate = '';
        let selectedTourTime = '';
        if (prospect && prospect.tourInterval != null) {
            selectedTourDate = moment(prospect.tourInterval.startDateTime).format('MM/DD/YY');
            selectedTourTime =
                moment(prospect.tourInterval.startDateTime).format('h:mm A') +
                '-' +
                moment(prospect.tourInterval.endDateTime).format('h:mm A');
        }
        let moveInDateDisplay = moment(prospect.moveInDate).format('MM/DD/YY');

        return {
            ...prospect,
            moveInDate: moveInDateDisplay,
            tourDate: selectedTourDate,
            timeSlot: selectedTourTime,
            status: prospect.status,
            name: `${prospect.firstName} ${prospect.lastName}`,
            phone: formatPhoneNumber(prospect.phone)
        };
    };

    return (
        <div className="prospectGrid">
            <ReactDataGrid
                onGridSort={props.onSort}
                columns={columns}
                rowGetter={rowGetter}
                rowsCount={props.rows.length}
                minHeight={400}
                onRowClick={(_rowIdx: number, row: FlatProspect) => {
                    if (row.publicKey) {
                        props.selectProspect(row.publicKey);
                    }
                }}
            />
        </div>
    );
};

export default ProspectGrid;



// WEBPACK FOOTER //
// ./src/components/common/ProspectGrid.tsx